
import {defineComponent} from 'vue'
import store, {ActionTypes} from '../../store'
import {mapState} from 'vuex'
import {useRouter} from 'vue-router'

export default defineComponent({
  name: 'StrategyUpdate',
  components: {},
  beforeRouteEnter(to, from, next) {
    const {id} = to.params
    const router = useRouter()
    store.dispatch(ActionTypes.INDEX_DELETE, id).then(() =>
        store.dispatch(ActionTypes.RESET_INDEX).then(() =>
            store.dispatch(ActionTypes.FETCH_PRODUCTS).then(() => next("/stratslist"))
        ))
  },

  computed: {
    ...mapState([
      'index'
    ])

  },

})
